import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { FooterComponent } from './footer/footer.component';
import { AuthGuard } from '../_helpers/auth.guard';
import { LoginComponent } from '../login/login.component';
import { LicensingComponent } from '../licensing/licensing.component';
import { RegisterComponent } from '../register/register.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';

const routes: Routes = [
  { path: '', redirectTo: 'licensing', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },

  {
    path: '', 
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'licensing',
        canActivate: [AuthGuard],
        loadChildren: () => import('../licensing/licensing.module').then(m => m.LicensingModule)
      },
      {
        path: 'utilities',
        canActivate: [AuthGuard],
        loadChildren: () => import('../utility/utility.module').then(m => m.UtilityModule)
      },
      {
        path: 'pricing',
        canActivate: [AuthGuard],
        loadChildren: () => import('../pricing/pricing.module').then(m => m.PricingModule)
      },
      {
        path: 'manage-user',
        canActivate: [AuthGuard],
        loadChildren: () => import('../manage-user/manage-user.module').then(m => m.ManageUserModule)
      },
      {
        path: 'platform',
        canActivate: [AuthGuard],
        loadChildren: () => import('../platform/platform.module').then(m => m.PlatformModule)
      },
      {
        path: 'partner-component',
        canActivate: [AuthGuard],
        loadChildren: () => import('../partner-component/partner-component.module').then(m => m.PartnerComponentModule)
      },
    ]
  },
  
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ThemeLayoutRoutingModule { }
